import { Button, Icon } from '@zoom/components';
import { TFunction } from 'i18next';
import React from 'react';
import { toast } from 'react-toastify';

import { UNDO_SCHEDULE_BUTTON_TAG, REDO_SCHEDULE_BUTTON_TAG } from '../constants';
import { ScheduleHistory } from '../types';

export interface UndoRedoProps {
  handleRewindSchedule: (statePosition: number) => void;
  scheduleHistory: ScheduleHistory;
  t: TFunction;
}

export const UndoRedo: React.FC<UndoRedoProps> = ({ handleRewindSchedule, scheduleHistory, t }) => {
  const { positionInHistory, schedulingStateHistory } = scheduleHistory;

  const undoSchedule = () => {
    const { actionType } = schedulingStateHistory[positionInHistory];

    handleRewindSchedule(positionInHistory - 1);

    if (actionType && actionType.snackBarMessage) {
      toast.success(t(`schedule.${actionType.type}Undo`));
    }
  };

  const redoSchedule = () => {
    const { actionType } = schedulingStateHistory[positionInHistory + 1];

    handleRewindSchedule(positionInHistory + 1);

    if (actionType && actionType.snackBarMessage) {
      toast.success(t(`schedule.${actionType.type}Redo`));
    }
  };

  return (
    <div className="undo-redo__container">
      <div className="undo-redo__undo-button">
        <Button
          data-test-id={UNDO_SCHEDULE_BUTTON_TAG}
          disabled={positionInHistory === 0}
          kind="icon-bg"
          onClick={undoSchedule}
          title={t('layout.action.undo')}
        >
          <Icon kind="chevron-left" color="#00a8e2" size={15} />
        </Button>
      </div>

      {/* TODO: Functionality with list of all history will be added in next iterations */}
      <div className="undo-redo__history-button">
        <Icon kind="history" color="#00a8e2" size={22} />
      </div>

      <div className="undo-redo__redo-button">
        <Button
          data-test-id={REDO_SCHEDULE_BUTTON_TAG}
          disabled={schedulingStateHistory.length === positionInHistory + 1}
          kind="icon-bg"
          onClick={redoSchedule}
          title={t('layout.action.redo')}
        >
          <Icon kind="chevron-right" color="#00a8e2" size={15} />
        </Button>
      </div>
    </div>
  );
};
